module.exports = __webpack_public_path__ + "static/media/marshall-homepage-reduced-more.e398b4f3.jpg";